import { combineReducers } from "redux";
import breadcrumbs from "./breadcrumbs";
import filters from "./filters";
import results from "./results";
import details from "./details";

export default combineReducers({ breadcrumbs, filters, results, details });
